import { useCurrencies } from "../../hooks/useCurrencies";
import currencyGuide from "../../pages/Wiki/Guides/CurrencyData";
import { useState, useEffect } from "react";

const Currencies = () => {
  const { data } = useCurrencies();
  const [currencies, setCurrencies] = useState([]);
  const [activeTooltip, setActiveTooltip] = useState(null);

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const merged = data.map((currency) => {
        const extraData = currencyGuide.sections.find((c) => c.id === currency.id);
        return {
          ...currency,
          ...extraData, // merges description, tradeable, etc.
        };
      });
      setCurrencies(merged);
    }
  }, [data]);

  const toggleTooltip = (id) => {
    setActiveTooltip((prev) => (prev === id ? null : id));
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4 mt-4">
      {currencies.map((cur) => (
        <div
          key={cur.id}
          className="relative bg-[var(--panel-sections)] p-4 rounded-xl shadow-md hover:shadow-lg transition flex flex-col items-center justify-between min-h-[160px]"
        >
          <div onClick={() => toggleTooltip(cur.id)} className="group cursor-pointer flex flex-col items-center">
            <img src={cur.image?.startsWith("http") ? cur.image : `https:${cur.image}`} alt={cur.name} className="w-12 h-12 object-contain mb-2" />
            <span className="text-sm font-semibold text-[var(--text-color)] text-center">{cur.name}</span>
          </div>

          {/* Tooltip (shown on click) */}
          {activeTooltip === cur.id && (
            <div className="absolute mt-2 left-0 w-64 bg-[var(--tooltip-bg)] text-[var(--text-color)] border-2 border-[var(--panel-outline-color)] text-xs p-3 rounded-lg shadow-lg z-50">
              <div
                dangerouslySetInnerHTML={{
                  __html: cur.description || "<em>No description available.</em>",
                }}
              />
              <div className="mt-2 space-y-1">
                <p>
                  <strong>Tradeable:</strong> {cur.tradeable ? "Yes" : "No"}
                </p>
                <p>
                  <strong>Withdrawable:</strong> {cur.canWithdraw ? "Yes" : "No"}
                </p>
                <p>
                  <strong>Obtainable:</strong> {cur.canGet ? "Yes" : "No"}
                </p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Currencies;
